import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

@Injectable({
	providedIn: 'root',
})
export class SnackbarService {
	constructor(public snackBar: MatSnackBar) {}

	display(
		displayMessage: string,
		snackbarPosition: any,
		pannelClass: string,
		action: string,
		duration: number
	) {
		this.snackBar.open(displayMessage, action, {
			verticalPosition: snackbarPosition,
			panelClass: pannelClass,
			duration: duration,
		});
	}
}
